import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import Placeholder from 'components/consumer/Placeholder';
import MobileAndTabletOnly from '../MobileAndTabletOnly';
import DesktopOnly from '../DesktopOnly';
const ImportantToggle = t0 => {
  const $ = _c(24);
  const {
    "aria-label": ariaLabel,
    loading: t1,
    items: t2,
    onClick: t3,
    selected
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const items = t4;
  const onClick = t3 === undefined ? _temp : t3;
  const t5 = ariaLabel || "";
  let t6;
  if ($[2] !== items || $[3] !== onClick) {
    let t7;
    if ($[5] !== onClick) {
      t7 = t8 => {
        const {
          contentId,
          id,
          label,
          infoTooltip,
          infoTooltipContent
        } = t8;
        return {
          contentId,
          id,
          onClick: () => {
            onClick(id);
          },
          label,
          infoTooltip: !!infoTooltip,
          infoTooltipContent: infoTooltipContent || ""
        };
      };
      $[5] = onClick;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    t6 = items.map(t7);
    $[2] = items;
    $[3] = onClick;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[7] !== selected || $[8] !== t5 || $[9] !== t6) {
    t7 = <MobileAndTabletOnly><div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] lg:hidden"><ToggleTabGroup aria-label={t5} selectedTab={selected} items={t6} styling="ImportantToggle" /></div></MobileAndTabletOnly>;
    $[7] = selected;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = ariaLabel || "";
  let t9;
  if ($[11] !== items || $[12] !== onClick) {
    let t10;
    if ($[14] !== onClick) {
      t10 = t11 => {
        const {
          contentId: contentId_0,
          id: id_0,
          label: label_0,
          description,
          infoTooltip: infoTooltip_0,
          infoTooltipContent: infoTooltipContent_0
        } = t11;
        return {
          contentId: contentId_0,
          id: id_0,
          onClick: () => {
            onClick(id_0);
          },
          label: label_0,
          description,
          infoTooltip: !!infoTooltip_0,
          infoTooltipContent: infoTooltipContent_0 || ""
        };
      };
      $[14] = onClick;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    t9 = items.map(t10);
    $[11] = items;
    $[12] = onClick;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[16] !== selected || $[17] !== t8 || $[18] !== t9) {
    t10 = <DesktopOnly><div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] max-[1023px]:hidden"><ToggleButtonGroup aria-label={t8} selectedItem={selected} items={t9} styling="ImportantToggle" /></div></DesktopOnly>;
    $[16] = selected;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== loading || $[21] !== t10 || $[22] !== t7) {
    t11 = <Placeholder loading={loading} type="rect" className="rounded mx-0 my-4 min-h-[45px] lg:m-0 lg:min-h-[60px]">{t7}{t10}</Placeholder>;
    $[20] = loading;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
ImportantToggle.propTypes = {
  'aria-label': PropTypes.string,
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentId: PropTypes.string.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    infoTooltip: PropTypes.bool,
    infoTooltipContent: PropTypes.string
  })),
  onClick: PropTypes.func,
  selected: PropTypes.string
};
export default ImportantToggle;
function _temp() {}